import React, { useRef } from "react";
import { useSelector } from "react-redux";
import { useReactToPrint } from "react-to-print";
import { Button, Grid, Table, Header } from "semantic-ui-react";
import { useLocation } from "react-router-dom";

const PdfFileNewFormet = () => {
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: "INVOICE",
    onAfterPrint: () => alert("print SUCCESS"),
  });
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const tempObj = Object.fromEntries(searchParams.entries());
  const dataObject = JSON.parse(tempObj.data);

  console.log(dataObject);
  const rowStyle = {
    borderBottom: "none", // Remove bottom border for each row
  };
  const stylesForPrint = `
  @media print {
    @page {
      margin: 20mm; /* Set margins */
    }
    body {
      margin: 0; /* Reset body margins */
    }
    .page-break {
      page-break-after: always; /* Ensure content breaks into a new page */
      margin-bottom: 50px; /* Set bottom space */
    }
  }
`;
  return (
    <>
      <div
        style={{
          padding: 10,
          marginBottom: 35,
          // width: "210mm",
        }}
      >
        <Button floated="right" onClick={handlePrint}>
          print
        </Button>
      </div>

      <div
        style={{
          position: "relative",
          minHeight: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "relative",
          padding: "50px",
          boxSizing: "border-box",
        }}
      >
        <div style={{ paddingBottom: "50px" }}>
          <div
            ref={componentRef}
            style={{
              width: "210mm",
              height: window.innerHeight,
              padding: 30,
              marginBottom: 35,
            }}
          >
            <style>{stylesForPrint}</style>
            <Grid>
              <Grid.Column width={5} floated="left">
                <Header as="h3">
                  PARMAR GROUP <br />
                  <Header.Subheader as="span">SILVER STAR</Header.Subheader>
                </Header>
              </Grid.Column>
              <Grid.Column width={7}>
                <Header as="h3" textAlign="right">
                  INVOICE
                </Header>
                <Table style={{ border: "none" }}>
                  <Table.Body>
                    <Table.Row className="noBottomBorder">
                      <Table.Cell textAlign="left">Date</Table.Cell>
                      <Table.Cell textAlign="right">
                        {dataObject?.date}
                      </Table.Cell>
                    </Table.Row>
                    <Table.Row className="noBottomBorder">
                      <Table.Cell textAlign="left">Customer Name</Table.Cell>
                      <Table.Cell textAlign="right">
                        {dataObject?.to}
                      </Table.Cell>
                    </Table.Row>
                    <Table.Row className="noBottomBorder">
                      <Table.Cell textAlign="left">Mobile</Table.Cell>
                      <Table.Cell textAlign="right">
                        {dataObject?.customerContact}
                      </Table.Cell>
                    </Table.Row>

                    <Table.Row className="noBottomBorder">
                      <Table.Cell textAlign="left">Invoice NO</Table.Cell>
                      <Table.Cell textAlign="right">
                        {dataObject?.invoiceNumber}
                      </Table.Cell>
                    </Table.Row>
                    <Table.Row className="noBottomBorder">
                      <Table.Cell textAlign="left">Person Name</Table.Cell>
                      <Table.Cell textAlign="right">
                        {dataObject?.personName}
                      </Table.Cell>
                    </Table.Row>
                    <Table.Row className="noBottomBorder">
                      <Table.Cell textAlign="left">Work </Table.Cell>
                      <Table.Cell textAlign="right">
                        {dataObject?.workName}
                      </Table.Cell>
                    </Table.Row>
                  </Table.Body>
                </Table>
              </Grid.Column>
            </Grid>
            <div className="page-break">
              <Table>
                <Table.Header>
                  <Table.Row>
                    {/* <Table.HeaderCell
                      width={2}
                      style={{ backgroundColor: "#00426a", color: "white" }}
                    >
                      Name
                    </Table.HeaderCell> */}
                    <Table.HeaderCell
                      style={{ backgroundColor: "#00426a", color: "white" }}
                    >
                      Description
                    </Table.HeaderCell>
                    <Table.HeaderCell
                      style={{ backgroundColor: "#00426a", color: "white" }}
                    >
                      Qty
                    </Table.HeaderCell>
                    <Table.HeaderCell
                      style={{ backgroundColor: "#00426a", color: "white" }}
                    >
                      Price
                    </Table.HeaderCell>
                    <Table.HeaderCell
                      style={{ backgroundColor: "#00426a", color: "white" }}
                    >
                      Tax
                    </Table.HeaderCell>
                    <Table.HeaderCell
                      style={{ backgroundColor: "#00426a", color: "white" }}
                    >
                      Recived Money
                    </Table.HeaderCell>
                    <Table.HeaderCell
                      style={{ backgroundColor: "#00426a", color: "white" }}
                    >
                      Total
                    </Table.HeaderCell>
                  </Table.Row>
                </Table.Header>

                <Table.Body>
                  {dataObject?.rowData?.map((item, index) => (
                    <Table.Row>
                      {/* <Table.Cell style={{ padding: "5px" }}>
                        {item?.itemName}
                      </Table.Cell> */}
                      <Table.Cell style={{ padding: "5px" }}>
                        {item?.itemDescription}
                      </Table.Cell>
                      <Table.Cell style={{ padding: "5px" }}>
                        {item?.itemQty}
                      </Table.Cell>
                      <Table.Cell style={{ padding: "5px" }}>
                        {item?.unitPrice}
                      </Table.Cell>
                      <Table.Cell style={{ padding: "5px" }}>
                        {item?.taxRate}
                      </Table.Cell>
                      <Table.Cell style={{ padding: "5px" }}>
                        {item?.disPer}
                      </Table.Cell>
                      <Table.Cell style={{ padding: "5px" }}>
                        {item?.amount}
                      </Table.Cell>
                    </Table.Row>
                  ))}
                  <Table.Row>
                    <Table.Cell
                      style={{
                        padding: "5px",
                      }}
                    ></Table.Cell>
                    {/* <Table.Cell style={{ padding: "5px" }}></Table.Cell> */}
                    <Table.Cell style={{ padding: "5px" }}></Table.Cell>
                    <Table.Cell style={{ padding: "5px" }}></Table.Cell>
                    <Table.Cell style={{ padding: "5px" }}></Table.Cell>
                    <Table.Cell style={{ padding: "5px" }}>
                      <b>
                        <h3>Total</h3>
                      </b>
                    </Table.Cell>
                    <Table.Cell style={{ padding: "5px" }}>
                      {" "}
                      <b>
                        <h3>{dataObject?.totalAmount}</h3>
                      </b>
                    </Table.Cell>
                  </Table.Row>
                </Table.Body>
              </Table>
              <div
                style={{
                  backgroundColor: "#f0f0f0",
                  width: "100%",
                  position: "absolute",
                  bottom: 0,
                  left: 0,
                  textAlign: "center",
                  padding: "10px",
                  // Hide by default for screen view
                }}
              >
                {/* Footer content */}
                <h4> Thank you for your business</h4>
                <div></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PdfFileNewFormet;

// style={{ padding: "10px" }}
